$(function() {
  if ($('.suggested-research-carousel') && $('.suggested-research-carousel').length > 0) {
    $('.suggested-research-carousel.owl-carousel').each(function() {
      var _this = this,
          itemPerSlide = $(_this).attr("data-slides-to-scroll") ? Number($(_this).attr("data-slides-to-scroll")) : 1;

      $(_this).owlCarousel({
        loop: false,
        autoplay: true,
        autoplayHoverPause: true,
        margin: 20,
        items: 4,
        nav: true,
        dots: false,
        slideBy: itemPerSlide,
        navText: [
          "<svg><use xlink:href='/dist/img/svg-sprite.svg#sorting-arrow-table'></use></svg>",
          "<svg><use xlink:href='/dist/img/svg-sprite.svg#sorting-arrow-table'></use></svg>"
        ],
        responsive: {
          0: {
            items: 1,
            slideBy: 1
          },
          620: {
            items: 1,
            slideBy: 1
          },
          992: {
            items: 2,
            slideBy: 1
          },
          1280:{
            items: 3,
            slideBy: itemPerSlide
          },
          1600: {
            items: 4,
            slideBy: itemPerSlide
          },
        },
      });     
    });
  }
});